import { Injectable } from '@angular/core';
import { LogService } from '../../shared/log/log.service';
import { UserPermission } from '../models/user-permission.model';
import 'polyfills';
import { DashboardFilterState } from '../../event/dashboard/dashboard-page/dashboard-filter';

@Injectable()
export class UserLocalStorageService {
  private readonly TOKEN_NAME = 'id_token';
  private readonly EMAIL_PREFIX = 'dashboard_filters_';

  constructor(
    private logService: LogService
  ) {}

  getToken(): string {
    try {
      return this.fromUserPermissions().token;
    } catch (error) {
      this.removeUserToken();
      this.logService.error('Unable to read token' + error);
      return null;
    }
  }

  getPermissions(): string[] {
    try {
      return this.fromUserPermissions().permissions;
    } catch (error) {
      this.removeUserToken();
      this.logService.error('Unable to read token' + error);
      return [];
    }
  }

  getDashboardFilterState(email: string): DashboardFilterState {
    email = this.EMAIL_PREFIX + email;
    const dashboardFilterStateJson = this.getItemAsJson(email);
    return new DashboardFilterState(dashboardFilterStateJson);
  }

  removeUserToken(): void {
    this.removeItem(this.TOKEN_NAME);
  }

  setUserToken(userPermission: UserPermission): void {
    this.setItem(this.TOKEN_NAME, JSON.stringify(userPermission));
  }

  setDashboardFilterState(email: string, dashboardFilterState: DashboardFilterState): void {
    email = this.EMAIL_PREFIX + email;
    this.setItem(email, JSON.stringify(dashboardFilterState))
  }

  private fromUserPermissions(): UserPermission {
    return new UserPermission(this.getItemAsJson(this.TOKEN_NAME));
  }

  setItem(key, value): void {
    localStorage.setItem(key, value);
  }

  getItem(key): string {
    return localStorage.getItem(key);
  }

  getItemAsJson(key): Object {
    try {
      const stringItem = this.getItem(key);
      if (stringItem != null) {
        return JSON.parse(stringItem);
      }
    } catch (error) {
      this.removeItem(key);
      this.logService.error('Unable to read token' + error);
    }

    return null;
  }

  removeItem(key): void {
    localStorage.removeItem(key);
  }

  get length(): number {
    return localStorage.length;
  }

  key(i): string {
    return localStorage.key(i);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/permission/services/user.local.storage.service.ts